// extracted by mini-css-extract-plugin
module.exports = {"block":"RequestResult_block__28grW","head":"RequestResult_head__3_8WX","edit":"RequestResult_edit__1fusH","body":"RequestResult_body__21ygr"};